var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUpAltSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ThumbUpAltSharp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.26648 0.583984L4.08398 4.77232V12.2507H11.2648L13.4173 7.23398V4.66732H8.56982L9.22315 1.52898L8.26648 0.583984ZM0.583984 5.25065H2.91732V12.2507H0.583984V5.25065Z",
    fill: "#5C576B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpAltSharp);
export default __webpack_public_path__ + "static/media/ThumbUpAltSharp.d86ab129362ba354da82105f202de5c4.svg";
export { ForwardRef as ReactComponent };